import ModalVideo from "react-modal-video";
import { useState } from "react";
import { trackButtonClick } from "@/utils/analytics";

const BuyingWithHubzu = ({
  cmsFAQData,
  isAllowedPreSale,
  wholeSalerProperty,
  propCategory,
  isForeclosure,
  propertyData
}) => {
  const [isOpen, setOpen] = useState(false);
  const getQuestionsFromCMS = (CMSKey) => {
    return cmsFAQData && cmsFAQData?.[CMSKey] && cmsFAQData?.[CMSKey]?.questions['@nodes'].map((key) => ({que: cmsFAQData?.[CMSKey]?.questions[key]?.que, ans: cmsFAQData?.[CMSKey]?.questions[key]?.ans}));
  }
  const questions =  getQuestionsFromCMS(
    isAllowedPreSale ? 'PRE_SALE' :
    wholeSalerProperty ? 'WHOLESALER' :
    propCategory === 'FORECLOSURE' ? 'FORECLOSURE' :
    propCategory === 'COMMERCIAL' ? 'COMMERCIAL' :
    propCategory === 'NON_REO' ? 'NON_REO' :
    propCategory === 'SHRT_SALE' ? 'SHRT_SALE' :
    'DEFAULT');
  const renderAccordians = (questions) => {
    const items = [];
    questions?.length > 0 &&
      questions.map((value, index) => {
        items.push(
          <div
            className=" accordion accordion-flush accordian-content"
            id="accordionFlushFAQ"
            key={`${value?.que}-${index}`}
          >
            <div className="accordion-item accordionBg">
              <h2 className="accordion-header">
                <button
                  className="pdpSubtitle2 accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={"#flush-" + index}
                  aria-expanded="false"
                  aria-controls={"flush-" + index}
                >
                  {value.que}
                </button>
              </h2>
              <div
                id={"flush-" + index}
                className="accordion-collapse collapse"
                tabIndex="0"
                // data-bs-parent="#accordionFlushFAQ"
              >
                <div dangerouslySetInnerHTML={{ __html: value.ans }}></div>
              </div>
            </div>
          </div>
        );
      });
    return items;
  };
  if (cmsFAQData && questions?.length !== 0) {
    return (
      <div className=" faqContainer application_statics mt30">
        <div className=" container px-1 px-sm-3">
          <div className="row">
            <>
              <h2 className="pdpSubtitle1 m38 pb30"  tabIndex="0">
                {propCategory == "FORECLOSURE" ? cmsFAQData?.FORECLOSURE?.title :
                propCategory == "NON_REO" ? cmsFAQData?.NON_REO?.title :
                propCategory == "SHRT_SALE" ? cmsFAQData?.SHRT_SALE?.title :
                cmsFAQData?.DEFAULT?.title}
              </h2>
              <p className="pdpBody3 pb30"  tabIndex="0">
                {propCategory == "FORECLOSURE" ? cmsFAQData?.FORECLOSURE?.description :
                propCategory == "NON_REO" ? cmsFAQData?.NON_REO?.description :
                propCategory == "SHRT_SALE" ? cmsFAQData?.SHRT_SALE?.description :
                cmsFAQData?.DEFAULT?.description}
              </p>
            </>
            <div className="col-sm-7 mb-3 mb-sm-0">
              <div
                className="accordion accordion-flush"
                 tabIndex="0"
                id="accordionFlushExample"
              >
                {renderAccordians(questions)}
              </div>
            </div>
            <ModalVideo
              channel="youtube"
              autoplay
              isOpen={isOpen}
              videoId={wholeSalerProperty ? cmsFAQData?.WHOLESALER?.videoKey : cmsFAQData?.DEFAULT?.videoKey}
              onClose={() => setOpen(false)}
            />
            <div className="col-sm-5">
              <div>
                <div className="property_video">
                  <div className="thumb"  tabIndex="0">
                    <img
                      className="cursor-pointer  w100 w-100 h-70 "
                      src={
                        wholeSalerProperty
                          ? cmsFAQData?.WHOLESALER?.image
                          : cmsFAQData?.DEFAULT?.image
                      }
                      alt="How hubzu auction works video"
                      onClick={() => {
                        setOpen(true);
                        trackButtonClick({
                          eventName: "video_on_pdp_clicked",
                          eventCategory: "NEW-PDP",
                          eventSource: "on video click",
                          eventLabel: `Video id:video1|${
                            propertyData?.propertyId
                          }|${propertyData?.listingId}|${
                            propertyData?.address?.streetNumber
                          } ${propertyData?.address?.streetName}, ${
                            propertyData?.address?.county
                          }, ${propertyData?.address?.city}, ${
                            propertyData?.address?.state
                          }, ${
                            propertyData?.address?.zip
                          }|Referrer: Other|Foreclosure Property:${
                            isForeclosure ? "Yes" : "No"
                          }|Status:${propertyData?.commonAttributes?.status}`,
                        });
                      }}
                      data-toggle={wholeSalerProperty && "tooltip"}
                      data-placement={wholeSalerProperty && "bottom"}
                      title={
                        wholeSalerProperty ?
                        "Learn how assignment contracts work" : ''
                      }
                    />
                    <div className="overlay_icon">
                      {/* <div
                        onClick={() => setOpen(true)}
                        role="button"
                        className="video_popup_btn red popup-youtube"
                      >
                        <span className="flaticon-play"></span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <ol className="list-group readFAQConatiner">
                <li className=" d-flex justify-content-between align-items-start ">
                  <div className="ms-2 me-auto">
                    <div className="pdpHeadingMedium mobile-fs">
                      Have more questions?
                    </div>
                    <p className="pdpTextDescriptionBlack "  tabIndex="0">
                      {" "}
                      Get answers here
                    </p>
                  </div>
                  <a
                    href="/support"
                    target="_blank"
                    className="btn hubzu-btn-thm faqCTA"
                    onClick={() => {
                      trackButtonClick({
                        eventName: "read_more_faqs",
                        eventCategory: "NEW-PDP",
                        eventSource: "on Read More FAQs click",
                        eventLabel: `ListingID: ${propertyData?.listingId}|PropertyID: ${propertyData?.propertyId}`,
                      });
                    }}
                  >
                    Read FAQs
                  </a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>{/* <ActivityIndicator size="large" color="#118bf4" /> */}</div>
    );
  }
};
export default BuyingWithHubzu;
